import React, { useState, useContext, useEffect } from "react";
import Column from "components/ui/layout/column/column";
import Row from "components/ui/layout/row/row";
import CardBox, { CardBoxHeader } from "components/ui/controls/card-box/card-box";
import { AppContext } from "../RemExprertProvider";
import { SaveCodesCourtier, User } from "../Api/ApiUser";
import TextField from "components/ui/controls/text-field/text-field";
import Button from "components/ui/controls/button/button";
import { createStyledButton } from "components/ui/controls/button/button-styles";
import { AuthContext } from "components/auth/auth-provider";
import { FaDownload, FaFile } from "react-icons/fa";
import { ApiUrl } from "../Api/ApiData";
import { saveAs } from "file-saver";
import axios from "axios";
import Modal from "components/ui/modal/modal";
const APIURL = ApiUrl;

export default function Formation() {
  const context = useContext(AppContext);
  const authContext = useContext(AuthContext);
  const [modalMakoFormation, setmodalMakoFormation] = useState(false);

  const DownloadDocument = (Data, CRUD) => {
    var formData = new FormData();
    formData.append("Data", JSON.stringify(Data));
    formData.append("CRUD", CRUD);

    var today = new Date();
    var dd = today.getDate();

    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }

    if (mm < 10) {
      mm = "0" + mm;
    }

    // ES6
    axios(`${APIURL}User/User.php`, {
      method: "post",
      data: formData,
      withCredentials: true,
      responseType: "blob",
      
      // headers: {
      //   "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
      // }
    }).then((response) => {
      // create file link in browser's memory
      console.log(response.data)
      const href = URL.createObjectURL(response.data);

      // create "a" HTML element with href to file & click
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", Data.name); //or any other extension
      document.body.appendChild(link);
      link.click();

      // clean up "a" element & remove ObjectURL
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    });

  };

  const updateLastTimeVisited=()=>{
    User({},"UpdateLastTimeVisited");
  }

  useEffect(() => {
       updateLastTimeVisited()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <Column fill className="formation-page" style={{ padding: '0px 20px 20px 20px', gap: '30px' }}>
      {/* Section GUIDES */}
      <div>
        <CardBox>
        <Column fill>
          <Row>
            <Column scroll fill>
              <div
                style={{
                  maxHeight: "600px",
                  overflow: "auto",
                  padding: "8px",
                }}
              >
                <CardBoxHeader icon={<FaDownload />}>
                  Liste des documents ({authContext.utilisateur_reel?.documents?.guides?.length || 0})
                </CardBoxHeader>

                {(!authContext.utilisateur_reel?.documents?.guides || authContext.utilisateur_reel?.documents?.guides.length === 0) ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "40px 20px",
                      color: "#6b7280",
                      fontFamily:
                        "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    }}
                  >
                    <FaDownload
                      style={{
                        fontSize: "48px",
                        marginBottom: "16px",
                        color: "#d1d5db",
                      }}
                    />
                    <p style={{ margin: 0, fontSize: "14px" }}>
                      Aucun guide trouvé
                    </p>
                  </div>
                ) : (
                  <div>
                    {authContext.utilisateur_reel?.documents?.guides?.map((Infos, Index) => (
                      <div
                        key={Index}
                        style={{
                          backgroundColor: "white",
                          borderRadius: "12px",
                          padding: "16px 20px",
                          marginBottom: "12px",
                          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                          border: "1px solid #f0f0f0",
                          transition: "all 0.2s ease",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          cursor: "pointer",
                        }}
                        onMouseOver={e => {
                          e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.12)";
                          e.currentTarget.style.transform = "translateY(-2px)";
                        }}
                        onMouseOut={e => {
                          e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
                          e.currentTarget.style.transform = "translateY(0)";
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <div style={{ display: "flex", alignItems: "center", marginBottom: "6px" }}>
                            <h4
                              style={{
                                margin: 0,
                                fontSize: "12px",
                                fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                                fontWeight: 600,
                                color: "#1f2937",
                              }}
                            >
                              {Infos.name}
                              {Infos.isNew === true && (
                                <span style={{
                                  marginLeft: "8px",
                                  backgroundColor: "#ef4444",
                                  color: "white",
                                  fontSize: "10px",
                                  padding: "2px 6px",
                                  borderRadius: "8px",
                                  fontWeight: "bold",
                                }}>
                                  NOUVEAU
                                </span>
                              )}
                            </h4>
                          </div>
                          <div
                            style={{
                              fontSize: "11px",
                              color: "#6b7280",
                              backgroundColor: "#f3f4f6",
                              padding: "2px 8px",
                              borderRadius: "12px",
                              display: "inline-block",
                              fontWeight: 500,
                            }}
                          >
                            {Infos.date}
                          </div>
                        </div>
                        <div style={{ marginLeft: "16px" }}>
                          {authContext.utilisateur_reel?.AccesMakoFormation === true ? (
                            <Button
                              onClick={() => {
                                DownloadDocument(
                                  {
                                    IdUser: context.state.IdUser,
                                    name: Infos.name,
                                    type: "Guides",
                                  },
                                  "DownloadDocument"
                                );
                              }}
                              icon
                              {...createStyledButton('card-action', 'download')}
                            >
                              <FaDownload style={{ fontSize: "12px", color: "#8b5cf6" }} />
                            </Button>
                          ) : (
                            <Button
                              onClick={() => {
                                setmodalMakoFormation(true);
                              }}
                              icon
                              {...createStyledButton('card-action', 'download')}
                            >
                              <FaDownload style={{ fontSize: "12px", color: "#8b5cf6" }} />
                            </Button>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Column>
          </Row>
        </Column>
      </CardBox>
      </div>

      <Modal
        width="80%"
        height="40%"
        title="Pack formation"
        visible={modalMakoFormation}
        onClose={() => {
          setmodalMakoFormation(false);
        }}
      >
        <Column fill>
          <CardBox bpad style={{ maxWidth: "800px" }}>
            <Column fill>
              <Row>
                <CardBoxHeader icon={<FaFile />}>Guides</CardBoxHeader>
              </Row>
              <Row style={{ maxHeight: "500px", overflow: "auto" }}>
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: "200px" }}>Date</th>
                      <th style={{ width: "500px" }}>Libellé</th>
                      <th style={{ width: "100px" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {authContext.utilisateur_reel?.documents?.guides?.map((Infos, Index) => {
                      return (
                        <tr key={Index}>
                          <td>{Infos.date}</td>
                          <td>{Infos.name} {Infos.isNew===true && <div className="badge"></div>}</td>
                          <td>
                            {authContext.utilisateur_reel?.AccesMakoFormation === true && (
                              <Button
                                onClick={() => {
                                  DownloadDocument(
                                    {
                                      IdUser: context.state.IdUser,
                                      name: Infos.name,
                                      type: "Guides",
                                    },
                                    "DownloadDocument"
                                  );
                                }}
                                icon
                                style={{ display: "inline-block" }}
                              >
                                <FaDownload />
                              </Button>
                            )}
                            {authContext.utilisateur_reel?.AccesMakoFormation === false && (
                              <Button
                                onClick={() => {
                                  setmodalMakoFormation(true);
                                }}
                                icon
                                style={{ display: "inline-block" }}
                              >
                                <FaDownload />
                              </Button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Row>
            </Column>
          </CardBox>
          <CardBox bpad style={{ maxWidth: "800px" }}>
            <Column fill>
              <Row>
                <CardBoxHeader icon={<FaFile />}>Newsletter</CardBoxHeader>
              </Row>
              <Row style={{ maxHeight: "500px", overflow: "auto" }}>
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: "200px" }}>Date</th>
                      <th style={{ width: "500px" }}>Libellé</th>
                      <th style={{ width: "100px" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {authContext.utilisateur_reel?.documents?.newsletter?.map((Infos, Index) => {
                      return (
                        <tr key={Index}>
                          <td>{Infos.date}</td>
                          <td>{Infos.name} {Infos.isNew===true && <div className="badge"></div>}</td>
                          <td>
                            {authContext.utilisateur_reel?.AccesMakoFormation === true && (
                              <Button
                                onClick={() => {
                                  DownloadDocument(
                                    {
                                      IdUser: context.state.IdUser,
                                      name: Infos.name,
                                      type: "NewsLetter",
                                    },
                                    "DownloadDocument"
                                  );
                                }}
                                icon
                                style={{ display: "inline-block" }}
                              >
                                <FaDownload />
                              </Button>
                            )}
                            {authContext.utilisateur_reel?.AccesMakoFormation === false && (
                              <Button
                                onClick={() => {
                                  setmodalMakoFormation(true);
                                }}
                                icon
                                style={{ display: "inline-block" }}
                              >
                                <FaDownload />
                              </Button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Row>
            </Column>
          </CardBox>
          <CardBox bpad style={{ maxWidth: "800px" }}>
            <Column fill>
              <Row>
                <CardBoxHeader icon={<FaFile />}>Supports de formation</CardBoxHeader>
              </Row>
              <Row style={{ maxHeight: "500px", overflow: "auto" }}>
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: "200px" }}>Date</th>
                      <th style={{ width: "500px" }}>Libellé</th>
                      <th style={{ width: "100px" }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {authContext.utilisateur_reel?.documents?.supports?.map((Infos, Index) => {
                      return (
                      
                        <tr key={Index}>
                          <td>{Infos.date}</td>
                          <td>{Infos.name} {Infos.isNew===true && <div className="badge"></div>}</td>
                          <td>
                            {authContext.utilisateur_reel?.AccesMakoFormation === true && (
                              <Button
                                onClick={() => {
                                  DownloadDocument(
                                    {
                                      IdUser: context.state.IdUser,
                                      name: Infos.name,
                                      type: "Supports",
                                    },
                                    "DownloadDocument"
                                  );
                                }}
                                icon
                                style={{ display: "inline-block" }}
                              >
                                <FaDownload />
                              </Button>
                            )}
                            {authContext.utilisateur_reel?.AccesMakoFormation === false && (
                              <Button
                                onClick={() => {
                                  setmodalMakoFormation(true);
                                }}
                                icon
                                style={{ display: "inline-block" }}
                              >
                                <FaDownload />
                              </Button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </Row>
            </Column>
          </CardBox>
          <Modal
            width="80%"
            height="40%"
            title="Pack formation"
            visible={modalMakoFormation}
            onClose={() => {
              setmodalMakoFormation(false);
            }}
          >
            <Column fill>
              <Row fill>
                <Column fill center style={{ color: "black", textAlign: "justify", marginTop: "32px" }}>
                  <br />
                  L'accès au pack formation est reservé aux utilisateurs ayant souscrit à l'option.
                  <br />
                  Pour plus d'informations, vous vous invitions à nous contacter à l'adresse suivante : contact@mako-remexpert.com
                  <br />
                  {/* <a href="mailto:contact@mako-remexpert.com">contact@mako-remexpert.com</a> */}
                  <br />
                  Le pack formation comprend les services ci dessous : <br />
                  <br />- Un guide complet sur la protection sociale: 150 pages de détails pédagogiques sous forme de fiches sur la retraite et la prévoyance du chef d’entreprise.
                  <br />- Des newsletters sur l'environnement sociale et fiscale du chef d'entreprise.
                  <br />- Une base de contrats de prévoyance TNS intégrée sur votre espace MAKO (une trentaine de contrats du marché sont analysés sur différents critères : délai d’attente,
                  exclusions, garanties, conditions de prise en charges des affections dorsales et psy, barème d’invalidité…).
                  <br />- Une calculette de points AGIRC ARRCO permettant de contrôler les points acquis.
                  <br />- Deux outils d’aide à la détermination et la déclaration du plafond PER dans le cadre de l’article 163 quatervicies du CGI : correction des anciens plafonds, calcul
                  du plafonds 2024.
                  <br />- Un outil d’aide à la vente du PER : mise en évidence de l’efficacité du dispositif : raisonnement net de fiscalité et de PS à l’entrée et à la sortie.
                  <br />
                  <br />
                </Column>
              </Row>
            </Column>
          </Modal>
        </Column>
      </Modal>

      <Modal
        width="80%"
        height="60%"
        title="Informations Pack Formation"
        visible={modalMakoFormation}
        onClose={() => {
          setmodalMakoFormation(false);
        }}
      >
        <Column fill>
          <Row fill>
            <Column fill center style={{ color: "black", textAlign: "justify", marginTop: "32px", padding: "20px" }}>
              <br />
              L'accès au pack formation est reservé aux utilisateurs ayant souscrit à l'option.
              <br />
              Pour plus d'informations, vous vous invitions à nous contacter à l'adresse suivante : contact@mako-remexpert.com
              <br />
              <br />
              Le pack formation comprend les services ci dessous : <br />
              <br />- Un guide complet sur la protection sociale: 150 pages de détails pédagogiques sous forme de fiches sur la retraite et la prévoyance du chef d'entreprise.
              <br />- Des newsletters sur l'environnement sociale et fiscale du chef d'entreprise.
              <br />- Une base de contrats de prévoyance TNS intégrée sur votre espace MAKO (une trentaine de contrats du marché sont analysés sur différents critères : délai d'attente,
              exclusions, garanties, conditions de prise en charges des affections dorsales et psy, barème d'invalidité…).
              <br />- Une calculette de points AGIRC ARRCO permettant de contrôler les points acquis.
              <br />- Deux outils d'aide à la détermination et la déclaration du plafond PER dans le cadre de l'article 163 quatervicies du CGI : correction des anciens plafonds, calcul
              du plafonds 2024.
              <br />- Un outil d'aide à la vente du PER : mise en évidence de l'efficacité du dispositif : raisonnement net de fiscalité et de PS à l'entrée et à la sortie.
              <br />
              <br />
            </Column>
          </Row>
        </Column>
      </Modal>
    </Column>
  );
}
